// Platform (superadmin only): photo quality of one workshop, advanced values
// included. `talleres_` keeps it out of the list page's layout.
import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { exigir } from '@/lib/guardias';
import { permisos } from '@/lib/sesion';
import { FotosTaller } from '@/plataforma/FotosTaller';
import { Boton } from '@/ui/boton';
import { Contenedor } from '@/ui/pagina';

export const Route = createFileRoute('/_app/plataforma/talleres_/$tallerId/fotos')({
  beforeLoad: exigir(permisos.plataforma),
  component: Pagina,
});

function Pagina() {
  const { tallerId } = Route.useParams();
  return (
    <Contenedor ancho="angosto" className="lg:max-w-[1120px]">
      <FotosTaller
        key={tallerId}
        tallerId={tallerId}
        volver={
          <Boton asChild variante="enlace" tamano="sm" className="self-start">
            <Link to="/plataforma/talleres">
              <ArrowLeft /> Talleres
            </Link>
          </Boton>
        }
      />
    </Contenedor>
  );
}
